(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[895],{

/***/ 3295:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[organisation]/[shopId]",
      function () {
        return __webpack_require__(168);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_imgix__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1748);



function Image(props) {
    let { url , alt , sizes , className , style , width =400 , height , fitMode =_utils_imgix__WEBPACK_IMPORTED_MODULE_2__/* .ImageFitMode.Clip */ .B.Clip  } = props;
    let srcset = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(()=>{
        return [
            0.5,
            1,
            2
        ].map((multiplier)=>{
            if (!url) return "";
            let calculatedWidth = width * multiplier;
            let calculatedHeight = height ? height * multiplier : undefined;
            return "".concat((0,_utils_imgix__WEBPACK_IMPORTED_MODULE_2__/* .generateImageLink */ .E)(url, calculatedWidth, calculatedHeight, fitMode), " ").concat(calculatedWidth, "w");
        }).join(",");
    }, [
        url
    ]);
    let fallback = url ? (0,_utils_imgix__WEBPACK_IMPORTED_MODULE_2__/* .generateImageLink */ .E)(url, width, height) : "#";
    return fallback ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        srcSet: srcset,
        sizes: sizes,
        src: fallback,
        alt: alt,
        title: alt,
        className: className,
        style: style
    }) : null;
}


/***/ }),

/***/ 2043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ TextField; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _react_aria_textfield__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3306);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




const TextField = (props)=>{
    let { label , error , onSubmit  } = props;
    let ref = react__WEBPACK_IMPORTED_MODULE_2__.useRef(null);
    const handleKeyDown = react__WEBPACK_IMPORTED_MODULE_2__.useCallback((e)=>{
        if ((e === null || e === void 0 ? void 0 : e.key) === "Enter") {
            if (ref && ref.current) {
                ref.current.blur();
            }
            if (onSubmit) {
                onSubmit();
            }
        }
    }, [
        onSubmit
    ]);
    let { labelProps , inputProps  } = (0,_react_aria_textfield__WEBPACK_IMPORTED_MODULE_3__/* .useTextField */ .E)({
        ...props,
        onKeyDown: handleKeyDown
    }, ref);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                ...labelProps,
                className: "font-medium text-gray-700",
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                ...inputProps,
                ref: ref,
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("border w-full p-2 rounded", {
                    "border-red-400": !!error,
                    "border-gray-300": !error
                })
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "my-1 text-red-600 text-sm font-medium",
                children: error
            })
        ]
    });
};


/***/ }),

/***/ 8045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ AppBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@translator-app/react/lib/index.js
var lib = __webpack_require__(1477);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(3789);
;// CONCATENATED MODULE: ./utils/getMobileOS.ts
var MobileOS;
(function(MobileOS) {
    MobileOS[MobileOS["IOS"] = 0] = "IOS";
    MobileOS[MobileOS["Android"] = 1] = "Android";
    MobileOS[MobileOS["Other"] = 2] = "Other";
})(MobileOS || (MobileOS = {}));
function getMobileOS() {
    if (true) {
        // @ts-ignore
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) {
            return MobileOS.Android;
        }
        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        // @ts-ignore
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return MobileOS.IOS;
        }
    }
    return MobileOS.Other;
}

;// CONCATENATED MODULE: ./components/organisms/app-banner.tsx






const AppBanner = (props)=>{
    const { url  } = props;
    const { translate  } = (0,lib.useTranslator)();
    const [showAndroidPopup, setShowAndroidPopup] = (0,react.useState)(false);
    const iosMetadataContent = [
        "app-id=".concat(constants/* IOS_APP_ID */.N3)
    ];
    if (url) {
        iosMetadataContent.push("app-argument=".concat(url));
    }
    const androidUrl = "http://play.google.com/store/apps/details?id=".concat(constants/* ANDROID_APP_ID */.mE);
    (0,react.useEffect)(()=>{
        setShowAndroidPopup(getMobileOS() === MobileOS.Android);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "apple-itunes-app",
                    content: iosMetadataContent.join(", ")
                })
            }),
            showAndroidPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center p-4 px-8 mx-auto max-w-screen-lg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-medium",
                            children: translate("appBanner.downloadAppText")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "bg-blue-600 text-white rounded px-4 py-2 font-medium",
                            href: androidUrl,
                            children: translate("appBanner.viewButton")
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 9922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ OrderHint; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _translator_app_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1477);
/* harmony import */ var _translator_app_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_translator_app_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _contexts_application_state_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(499);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5075);






const OrderHint = ()=>{
    let { order , organisation  } = (0,_contexts_application_state_context__WEBPACK_IMPORTED_MODULE_4__/* .useApplicationState */ .jm)();
    let router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    let { translate  } = (0,_translator_app_react__WEBPACK_IMPORTED_MODULE_1__.useTranslator)();
    if ((order === null || order === void 0 ? void 0 : order.status) !== _generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .OrderStatusEnumType.Created */ .GQ.Created) {
        return null;
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "max-w-screen-xl mx-auto py-4",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "px-8",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: "/".concat(router.locale, "/").concat(organisation.pathname, "/").concat(order.shopId, "/order/overview"),
                    className: "block w-full px-2 py-2 rounded border bg-brand-600 text-white mb-8 text-center font-medium",
                    children: translate("order.openOrderLink")
                })
            })
        });
    }
};


/***/ }),

/***/ 5075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fl": function() { return /* binding */ ReservationStatusEnumType; },
/* harmony export */   "GQ": function() { return /* binding */ OrderStatusEnumType; },
/* harmony export */   "Go": function() { return /* binding */ LanguageEnum; },
/* harmony export */   "Rx": function() { return /* binding */ UnitEnumType; }
/* harmony export */ });
/* unused harmony exports AllergensEnumType, AuthTypeEnum, ConnectionStatusEnum, CountryEnum, DeviceLogOperationEnum, DeviceLogTypeEnum, FirmwareTypeEnum, LockStatusEnum, LockerTemperatureTypeEnum, LogOperationEnum, NotificationTypeEnumType, QuotaTypeEnumType, SeverityEnumType, SortEnumType, UserRoleReferenceTypeEnum */
var AllergensEnumType;
(function(AllergensEnumType) {
    AllergensEnumType[/** Product contains peanuts */ "Peanuts"] = "peanuts";
    AllergensEnumType[/** Product contains nuts */ "Nuts"] = "nuts";
    AllergensEnumType[/** Product contains crustaceans (a type of shellfish) */ "Crustaceans"] = "crustaceans";
    AllergensEnumType[/** Product contains molluscs (a type of shellfish) */ "Molluscs"] = "molluscs";
    AllergensEnumType[/** Product contains fish */ "Fish"] = "fish";
    AllergensEnumType[/** Product contains eggs */ "Eggs"] = "eggs";
    AllergensEnumType[/** Product contains milk */ "Milk"] = "milk";
    AllergensEnumType[/** Product contains gluten */ "Gluten"] = "gluten";
    AllergensEnumType[/** Product contains soya */ "Soya"] = "soya";
    AllergensEnumType[/** Product contains sesame seeds */ "Sesame"] = "sesame";
    AllergensEnumType[/** Product contains celery */ "Celery"] = "celery";
    AllergensEnumType[/** Product contains mustard */ "Mustard"] = "mustard";
    AllergensEnumType[/** Product contains lupin */ "Lupin"] = "lupin";
    AllergensEnumType[/** Product contains sulphur dioxide */ "SulphurDioxide"] = "sulphurDioxide";
})(AllergensEnumType || (AllergensEnumType = {}));
var AuthTypeEnum;
(function(AuthTypeEnum) {
    AuthTypeEnum["Api"] = "api";
    AuthTypeEnum["User"] = "user";
})(AuthTypeEnum || (AuthTypeEnum = {}));
var ConnectionStatusEnum;
(function(ConnectionStatusEnum) {
    ConnectionStatusEnum[/** Device is online */ "Online"] = "Online";
    ConnectionStatusEnum[/** Device is offline */ "Offline"] = "Offline";
})(ConnectionStatusEnum || (ConnectionStatusEnum = {}));
var CountryEnum;
(function(CountryEnum) {
    CountryEnum["Be"] = "be";
    CountryEnum["Nl"] = "nl";
    CountryEnum["Fr"] = "fr";
    CountryEnum["De"] = "de";
    CountryEnum["At"] = "at";
})(CountryEnum || (CountryEnum = {}));
var DeviceLogOperationEnum;
(function(DeviceLogOperationEnum) {
    DeviceLogOperationEnum["State"] = "State";
    DeviceLogOperationEnum["Error"] = "Error";
    DeviceLogOperationEnum["LockerState"] = "LockerState";
    DeviceLogOperationEnum["RequestLockerConfig"] = "RequestLockerConfig";
    DeviceLogOperationEnum["TerminalAction"] = "TerminalAction";
    DeviceLogOperationEnum["RequestLatestVersion"] = "RequestLatestVersion";
    DeviceLogOperationEnum["Unknown"] = "Unknown";
    DeviceLogOperationEnum["GatewayConfigUpdate"] = "GatewayConfigUpdate";
    DeviceLogOperationEnum["LockerUpdate"] = "LockerUpdate";
    DeviceLogOperationEnum["OpenLocks"] = "OpenLocks";
    DeviceLogOperationEnum["ForceUpdate"] = "ForceUpdate";
    DeviceLogOperationEnum["LatestVersion"] = "LatestVersion";
})(DeviceLogOperationEnum || (DeviceLogOperationEnum = {}));
var DeviceLogTypeEnum;
(function(DeviceLogTypeEnum) {
    DeviceLogTypeEnum["Command"] = "Command";
    DeviceLogTypeEnum["Event"] = "Event";
})(DeviceLogTypeEnum || (DeviceLogTypeEnum = {}));
var FirmwareTypeEnum;
(function(FirmwareTypeEnum) {
    FirmwareTypeEnum["GatewayV1"] = "GatewayV1";
    FirmwareTypeEnum["LockControllerV1"] = "LockControllerV1";
    FirmwareTypeEnum["PinpadControllerV1"] = "PinpadControllerV1";
})(FirmwareTypeEnum || (FirmwareTypeEnum = {}));
var LanguageEnum;
(function(LanguageEnum) {
    LanguageEnum["Nl"] = "nl";
    LanguageEnum["Fr"] = "fr";
    LanguageEnum["En"] = "en";
    LanguageEnum["De"] = "de";
})(LanguageEnum || (LanguageEnum = {}));
var LockStatusEnum;
(function(LockStatusEnum) {
    LockStatusEnum[/** Lock is open */ "Open"] = "open";
    LockStatusEnum[/** Lock is closed */ "Closed"] = "closed";
})(LockStatusEnum || (LockStatusEnum = {}));
var LockerTemperatureTypeEnum;
(function(LockerTemperatureTypeEnum) {
    LockerTemperatureTypeEnum[/** Locker does not do any temperature control at all */ "NotCooled"] = "NotCooled";
    LockerTemperatureTypeEnum[/** Locker keeps room temperature (12-25°C) */ "RoomTemperature"] = "RoomTemperature";
    LockerTemperatureTypeEnum[/** Locker keeps refrigerator temperatures (3-6°C) */ "Refrigerated"] = "Refrigerated";
    LockerTemperatureTypeEnum[/** Locker keeps warm temperatures (60-80°C) */ "Heated"] = "Heated";
})(LockerTemperatureTypeEnum || (LockerTemperatureTypeEnum = {}));
var LogOperationEnum;
(function(LogOperationEnum) {
    LogOperationEnum["Received"] = "Received";
    LogOperationEnum["Sent"] = "Sent";
    LogOperationEnum["Opened"] = "Opened";
    LogOperationEnum["Error"] = "Error";
    LogOperationEnum["Created"] = "Created";
    LogOperationEnum["Updated"] = "Updated";
    LogOperationEnum["Deleted"] = "Deleted";
})(LogOperationEnum || (LogOperationEnum = {}));
var NotificationTypeEnumType;
(function(NotificationTypeEnumType) {
    NotificationTypeEnumType[/** Send sms notification */ "Sms"] = "sms";
    NotificationTypeEnumType[/** Send email notification */ "Email"] = "email";
})(NotificationTypeEnumType || (NotificationTypeEnumType = {}));
var OrderStatusEnumType;
(function(OrderStatusEnumType) {
    OrderStatusEnumType[/** Order has been created, not paid */ "Created"] = "Created";
    OrderStatusEnumType[/** Order has been paid */ "Paid"] = "Paid";
    OrderStatusEnumType[/** Order has expired */ "Expired"] = "Expired";
    OrderStatusEnumType[/** Pending order payment has been expired */ "PaymentExpired"] = "PaymentExpired";
    OrderStatusEnumType[/** Order has been canceled manually */ "Canceled"] = "Canceled";
    OrderStatusEnumType[/** Pending order payment has been canceled */ "PaymentCanceled"] = "PaymentCanceled";
    OrderStatusEnumType[/** Order has been refunded, this can only be done manually in the Mollie dashboard */ "Refunded"] = "Refunded";
})(OrderStatusEnumType || (OrderStatusEnumType = {}));
var QuotaTypeEnumType;
(function(QuotaTypeEnumType) {
    QuotaTypeEnumType[/** Quota is of type SMS */ "Sms"] = "SMS";
    QuotaTypeEnumType[/** Quota is of type Reservations */ "Reservations"] = "Reservations";
    QuotaTypeEnumType[/** Quota is of type Customers */ "Customers"] = "Customers";
    QuotaTypeEnumType[/** Quota is of type Emails */ "Emails"] = "Emails";
    QuotaTypeEnumType[/** Quota is of type Users */ "Users"] = "Users";
    QuotaTypeEnumType[/** Quota is of type Products */ "Products"] = "Products";
    QuotaTypeEnumType[/** Quota is of type Uploads */ "Uploads"] = "Uploads";
})(QuotaTypeEnumType || (QuotaTypeEnumType = {}));
var ReservationStatusEnumType;
(function(ReservationStatusEnumType) {
    ReservationStatusEnumType[/** Reservation has been cancelled */ "Cancelled"] = "cancelled";
    ReservationStatusEnumType[/** Reservation has been created */ "Created"] = "created";
    ReservationStatusEnumType[/** A box in the locker has been reserved */ "Reserved"] = "reserved";
    ReservationStatusEnumType[/**
   * Reservation has been ordered in the vending machine, not neccessarily paid. If
   * order gets cancelled or expires it will return to reserved.
   */ "Ordered"] = "ordered";
    ReservationStatusEnumType[/** Reservation ready notifications have been sent */ "Sent"] = "sent";
    ReservationStatusEnumType[/** Reservation has been picked up */ "Completed"] = "completed";
})(ReservationStatusEnumType || (ReservationStatusEnumType = {}));
var SeverityEnumType;
(function(SeverityEnumType) {
    SeverityEnumType["Info"] = "info";
    SeverityEnumType["Success"] = "success";
    SeverityEnumType["Warning"] = "warning";
    SeverityEnumType["Danger"] = "danger";
})(SeverityEnumType || (SeverityEnumType = {}));
var SortEnumType;
(function(SortEnumType) {
    SortEnumType["Asc"] = "asc";
    SortEnumType["Desc"] = "desc";
})(SortEnumType || (SortEnumType = {}));
var UnitEnumType;
(function(UnitEnumType) {
    UnitEnumType[/** Product is expressed in amount */ "Unit"] = "unit";
    UnitEnumType[/** Product/Price is per kilogram */ "Kg"] = "kg";
    UnitEnumType[/** Product/Price is per liter */ "Liter"] = "liter";
})(UnitEnumType || (UnitEnumType = {}));
var UserRoleReferenceTypeEnum;
(function(UserRoleReferenceTypeEnum) {
    UserRoleReferenceTypeEnum[/** An organisation/customer of the viresmo platform */ "Organisation"] = "Organisation";
    UserRoleReferenceTypeEnum[/** A dealer of the viresmo platform */ "Dealer"] = "Dealer";
    UserRoleReferenceTypeEnum[/** A reseller of the viresmo platform */ "Reseller"] = "Reseller";
})(UserRoleReferenceTypeEnum || (UserRoleReferenceTypeEnum = {}));


/***/ }),

/***/ 168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Index; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _translator_app_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1477);
/* harmony import */ var _translator_app_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_translator_app_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var fuse_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(4221);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var _components_atoms_button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7997);
/* harmony import */ var _components_atoms_heading__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2061);
/* harmony import */ var _components_atoms_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2881);
/* harmony import */ var _components_atoms_textfield__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2043);
/* harmony import */ var _components_organisms_app_banner__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8045);
/* harmony import */ var _components_organisms_error_boundary__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3570);
/* harmony import */ var _components_organisms_not_found__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1425);
/* harmony import */ var _components_organisms_order_hint__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9922);
/* harmony import */ var _components_templates_fallback_page_template__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9169);
/* harmony import */ var _components_templates_shop_page_template__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6781);
/* harmony import */ var _contexts_application_state_context__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(499);
/* harmony import */ var _contexts_language_context__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5262);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(5075);
/* harmony import */ var _utils_currency__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(8734);
/* harmony import */ var _utils_imgix__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(1748);
/* harmony import */ var _utils_invariant__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(8793);
/* harmony import */ var _utils_number__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(7627);
/* harmony import */ var _utils_phonenumber__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(1311);
/* harmony import */ var _utils_product__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(996);

























const CAROUSEL_TIMEOUT = 5000;
function ProductCard(props) {
    let { reservation , organisation  } = props;
    let router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    let { addToCart , shopId  } = (0,_contexts_application_state_context__WEBPACK_IMPORTED_MODULE_15__/* .useApplicationState */ .jm)();
    let [shownImage, setShownImage] = react__WEBPACK_IMPORTED_MODULE_4__.useState(0);
    let [images, setImages] = react__WEBPACK_IMPORTED_MODULE_4__.useState([]);
    let [carouselTimeout, setCarouselTimeout] = react__WEBPACK_IMPORTED_MODULE_4__.useState(null);
    let { language  } = (0,_contexts_language_context__WEBPACK_IMPORTED_MODULE_16__/* .useLanguageContext */ .Q)();
    let { translate  } = (0,_translator_app_react__WEBPACK_IMPORTED_MODULE_1__.useTranslator)();
    const reservationPrices = react__WEBPACK_IMPORTED_MODULE_4__.useMemo(()=>{
        return (0,_utils_product__WEBPACK_IMPORTED_MODULE_21__/* .getReservationPrices */ .tF)(reservation);
    }, [
        reservation
    ]);
    let name = react__WEBPACK_IMPORTED_MODULE_4__.useMemo(()=>{
        return (0,_utils_product__WEBPACK_IMPORTED_MODULE_21__/* .getReservationProductsName */ .nd)(reservation, language) || "Removed product";
    }, [
        reservation.vendingProducts
    ]);
    let discountPercentage = react__WEBPACK_IMPORTED_MODULE_4__.useMemo(()=>{
        return (reservation === null || reservation === void 0 ? void 0 : reservation.vendingDiscount) ? (0,_utils_number__WEBPACK_IMPORTED_MODULE_20__/* .formatAmount */ .dN)(reservation.vendingDiscount / 100) : "";
    }, [
        reservation
    ]);
    react__WEBPACK_IMPORTED_MODULE_4__.useEffect(()=>{
        setImages((0,_utils_product__WEBPACK_IMPORTED_MODULE_21__/* .getReservationProductImages */ .iK)(reservation));
        setShownImage(0);
    }, [
        reservation.vendingProducts
    ]);
    react__WEBPACK_IMPORTED_MODULE_4__.useEffect(()=>{
        if (true) {
            if (carouselTimeout) {
                clearTimeout(carouselTimeout);
            }
            let timeout = setTimeout(()=>{
                if (shownImage < images.length - 1) {
                    setShownImage(shownImage + 1);
                } else {
                    setShownImage(0);
                }
            }, CAROUSEL_TIMEOUT);
            setCarouselTimeout(timeout);
            return ()=>{
                clearTimeout(timeout);
            };
        }
    }, [
        images,
        shownImage,
        "object"
    ]);
    const isSold = reservation.status !== _generated_graphql__WEBPACK_IMPORTED_MODULE_17__/* .ReservationStatusEnumType.Reserved */ .Fl.Reserved;
    var _vendingDiscount;
    const vendingDiscount = (_vendingDiscount = reservation.vendingDiscount) !== null && _vendingDiscount !== void 0 ? _vendingDiscount : 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative w-full bg-white border grid grid-col-1",
        style: {
            gridTemplateRows: "auto 1fr auto"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full h-auto relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: "/[organisation]/[shopId]/product/[reservationId]",
                        as: "/".concat(organisation.pathname, "/").concat(shopId, "/product/").concat(reservation._id),
                        children: images.length > shownImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_image__WEBPACK_IMPORTED_MODULE_7__/* .Image */ .E, {
                            url: images[shownImage],
                            width: 500,
                            height: 500,
                            fitMode: _utils_imgix__WEBPACK_IMPORTED_MODULE_19__/* .ImageFitMode.Crop */ .B.Crop,
                            sizes: "(max-width: 500px) 400px, 800px",
                            alt: name,
                            className: "w-full h-auto overflow-hidden"
                        })
                    }),
                    (!!discountPercentage || isSold) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute m-2 text-lg font-bold py-2 px-4 bg-red-600 text-white",
                        style: {
                            top: 5,
                            right: 5
                        },
                        children: isSold ? translate("product.sold") : "-".concat(discountPercentage, "%")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pt-6 pb-2 px-8 text-center text-xl uppercase font-bold text-gray-900 leading-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: "/[organisation]/[shopId]/product/[reservationId]",
                    as: "/".concat(organisation.pathname, "/").concat(shopId, "/product/").concat(reservation._id),
                    children: name
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center w-full py-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-2",
                        children: [
                            vendingDiscount > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "uppercase text-gray-700 line-through",
                                children: (0,_utils_currency__WEBPACK_IMPORTED_MODULE_18__/* .formatCurrency */ .x)(reservationPrices.totalPrice)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xl uppercase text-gray-800 font-bold",
                                children: (0,_utils_currency__WEBPACK_IMPORTED_MODULE_18__/* .formatCurrency */ .x)(reservationPrices.totalPriceWithDiscount)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full flex justify-center py-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/[organisation]/[shopId]/product/[reservationId]",
                                    as: "/".concat(organisation.pathname, "/").concat(shopId, "/product/").concat(reservation._id),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_button__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
                                        size: "sm",
                                        children: translate("product.infoButtonText")
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "ml-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_button__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
                                    size: "sm",
                                    appearance: "primary",
                                    disabled: isSold,
                                    onPress: ()=>{
                                        if (isSold) return;
                                        addToCart([
                                            reservation
                                        ]);
                                        router.push("/[organisation]/[shopId]/order/shopping-cart", "/".concat(organisation.pathname, "/").concat(shopId, "/order/shopping-cart"));
                                    },
                                    children: translate(isSold ? "product.sold" : "product.orderButtonText")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function PageContent(props) {
    const { shop , organisation  } = props;
    const { reservations  } = (0,_contexts_application_state_context__WEBPACK_IMPORTED_MODULE_15__/* .useApplicationState */ .jm)();
    const { translate , language  } = (0,_translator_app_react__WEBPACK_IMPORTED_MODULE_1__.useTranslator)();
    const [searchValue, setSearchValue] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("");
    const sortedReservations = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(()=>{
        if (!searchValue || !reservations.length) {
            return reservations;
        }
        const availableReservations = reservations.filter((r)=>r.status === _generated_graphql__WEBPACK_IMPORTED_MODULE_17__/* .ReservationStatusEnumType.Reserved */ .Fl.Reserved);
        // Search in available reservations...
        const mappedValues = availableReservations.map((r)=>{
            const productNames = r.vendingProducts.map((p)=>p.product ? (0,_utils_product__WEBPACK_IMPORTED_MODULE_21__/* .getLocalisedString */ .T7)(p.product.name, language) : "").filter(Boolean);
            return {
                productNames
            };
        });
        const fuse = new fuse_js__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z(mappedValues, {
            isCaseSensitive: false,
            keys: [
                "productNames"
            ]
        });
        return fuse.search(searchValue).map((v)=>availableReservations[v.refIndex]);
    }, [
        reservations,
        searchValue,
        language
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "bg-white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "max-w-screen-xl mx-auto p-8",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "md:flex flex-row-reverse justify-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: (organisation === null || organisation === void 0 ? void 0 : organisation.logoUrl) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "h-36 w-36 overflow-hidden mb-6 md:mb-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_image__WEBPACK_IMPORTED_MODULE_7__/* .Image */ .E, {
                                        url: organisation.logoUrl,
                                        alt: shop.name,
                                        width: 150,
                                        height: 150,
                                        sizes: "150px"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_heading__WEBPACK_IMPORTED_MODULE_6__/* .Heading */ .X, {
                                                children: shop.name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                children: [
                                                    shop.address.street,
                                                    " ",
                                                    shop.address.streetNumber,
                                                    " • ",
                                                    shop.address.zipcode,
                                                    " ",
                                                    shop.address.city
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                children: [
                                                    "TEL ",
                                                    (0,_utils_phonenumber__WEBPACK_IMPORTED_MODULE_23__/* .formatPhonenumber */ .t)(shop.phonenumber)
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-gray-800 font-medium rounded my-4",
                                        children: translate("overview.pickupOrderWithin", {
                                            vendingPickupTime: shop.vendingPickupTime.toString(10)
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms_order_hint__WEBPACK_IMPORTED_MODULE_12__/* .OrderHint */ .H, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-screen-xl mx-auto px-8 pt-8 pb-16",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_heading__WEBPACK_IMPORTED_MODULE_6__/* .Heading */ .X, {
                        children: translate("products.currentlyAvailableTitle")
                    }),
                    sortedReservations.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_textfield__WEBPACK_IMPORTED_MODULE_8__/* .TextField */ .n, {
                                    label: translate("products.search"),
                                    onChange: (val)=>setSearchValue(val),
                                    value: searchValue
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "grid sm:grid-cols-2 lg:grid-cols-3 gap-8",
                                children: sortedReservations.map((reservation)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductCard, {
                                        reservation: reservation,
                                        organisation: (0,_utils_invariant__WEBPACK_IMPORTED_MODULE_24__/* .nullthrows */ .W)(organisation, "Organisation not found")
                                    }, reservation._id);
                                })
                            }),
                            !!shop.webshopUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col items-center my-8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-md mb-2",
                                        children: translate("productsOverview.webshopFallbackTitle")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_button__WEBPACK_IMPORTED_MODULE_5__/* .LinkButton */ .Q, {
                                        href: shop.webshopUrl,
                                        children: translate("productsOverview.webshopLinkButtonText")
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex justify-center font-medium text-xl text-gray-700 my-32 text-center",
                                children: translate("products.noProductsAvailable")
                            }),
                            !!shop.webshopUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex flex-col items-center my-8",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_button__WEBPACK_IMPORTED_MODULE_5__/* .LinkButton */ .Q, {
                                    href: shop.webshopUrl,
                                    children: translate("productsOverview.webshopLinkButtonText")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var __N_SSP = true;
function Index(props) {
    let { organisation , shop , shoppingCart , order , reservations , error  } = props;
    if (error) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_fallback_page_template__WEBPACK_IMPORTED_MODULE_13__/* .FallbackPageTemplate */ .w, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms_error_boundary__WEBPACK_IMPORTED_MODULE_10__/* .ErrorFallback */ .H, {
                error: error
            })
        });
    }
    if (!organisation) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_fallback_page_template__WEBPACK_IMPORTED_MODULE_13__/* .FallbackPageTemplate */ .w, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms_not_found__WEBPACK_IMPORTED_MODULE_11__/* .NotFound */ .T, {})
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_templates_shop_page_template__WEBPACK_IMPORTED_MODULE_14__/* .ShopPageTemplate */ .g, {
        organisation: organisation,
        shop: shop,
        shoppingCart: shoppingCart,
        order: order,
        reservations: reservations,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms_app_banner__WEBPACK_IMPORTED_MODULE_9__/* .AppBanner */ .y, {
                url: shop._id ? "woyti://shop/".concat(shop._id) : "woyti://"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageContent, {
                ...props
            })
        ]
    });
}


/***/ }),

/***/ 8734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* harmony import */ var currency_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6740);
/* harmony import */ var currency_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(currency_js__WEBPACK_IMPORTED_MODULE_0__);

function formatCurrency(value) {
    let opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    let { isCentValue =true , showEuroSign =true  } = opts;
    let amount = isCentValue ? value / 100 : value;
    return currency_js__WEBPACK_IMPORTED_MODULE_0___default()(amount, {
        symbol: showEuroSign ? "€ " : "",
        separator: ".",
        decimal: ","
    }).format().trim();
}


/***/ }),

/***/ 8793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ nullthrows; }
/* harmony export */ });
/* unused harmony export invariant */
const prefix = "Invariant failed";
// Throw an error if the condition fails
// Strip out error messages for production
// > Not providing an inline default argument for message as the result is smaller
function invariant(condition, // Can provide a string, or a function that returns a string for cases where
// the message takes a fair amount of effort to compute
message) {
    if (condition) {
        return;
    }
    const provided = typeof message === "function" ? message() : message;
    // Options:
    // 1. message provided: `${prefix}: ${provided}`
    // 2. message not provided: prefix
    const value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}
function nullthrows(value, message) {
    invariant(value != null, message);
    return value;
}


/***/ }),

/***/ 7627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dN": function() { return /* binding */ formatAmount; },
/* harmony export */   "uu": function() { return /* binding */ formatProductUnitAmount; }
/* harmony export */ });
/* unused harmony exports formatTemperature, formatPercentage */
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5075);

function formatAmount(value) {
    let unit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", decimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2, enforceDecimals = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    let formattedValue = Math.round(value * 10 ** decimals) / 10 ** decimals;
    if (enforceDecimals) {
        formattedValue = formattedValue.toFixed(decimals);
    } else {
        formattedValue = formattedValue.toString();
    }
    return "".concat(formattedValue.replace(".", ",")).concat(unit ? unit : "");
}
function formatTemperature(value) {
    return formatAmount(value, "\xb0C");
}
function formatPercentage(value) {
    return formatAmount(value * 100, "%");
}
function formatProductUnitAmount(amount, unitType) {
    if (unitType === _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UnitEnumType.Unit */ .Rx.Unit) {
        return "".concat(amount.toString(10), "x");
    }
    let value = amount;
    if (amount > 1000) {
        value = amount / 1000;
    }
    let suffix = "";
    if (unitType === _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UnitEnumType.Liter */ .Rx.Liter) {
        suffix = amount > 1000 ? "l" : "cl";
    } else {
        suffix = amount > 1000 ? "kg" : "g";
    }
    return formatAmount(value, suffix, 2, amount > 1000);
}


/***/ }),

/***/ 996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E5": function() { return /* binding */ getProductCollectionItemsSummary; },
/* harmony export */   "T7": function() { return /* binding */ getLocalisedString; },
/* harmony export */   "iK": function() { return /* binding */ getReservationProductImages; },
/* harmony export */   "nd": function() { return /* binding */ getReservationProductsName; },
/* harmony export */   "tF": function() { return /* binding */ getReservationPrices; }
/* harmony export */ });
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5075);
/* harmony import */ var _number__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7627);


function getLocalisedString(value) {
    let language = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .LanguageEnum.Nl */ .Go.Nl;
    var ref;
    let foundValue = value.find((i)=>i.language === language);
    return foundValue ? foundValue.value : ((ref = value[0]) === null || ref === void 0 ? void 0 : ref.value) || "";
}
function getReservationProductsName(reservation) {
    let language = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .LanguageEnum.Nl */ .Go.Nl;
    let nameValues = reservation.vendingProducts.filter((p)=>{
        var ref;
        return !!(p === null || p === void 0 ? void 0 : (ref = p.product) === null || ref === void 0 ? void 0 : ref.name);
    }).map((p)=>{
        var ref;
        var ref1;
        return "".concat((0,_number__WEBPACK_IMPORTED_MODULE_1__/* .formatProductUnitAmount */ .uu)(p.amount, (ref1 = (ref = p.product) === null || ref === void 0 ? void 0 : ref.unitType) !== null && ref1 !== void 0 ? ref1 : _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UnitEnumType.Unit */ .Rx.Unit), " ").concat(p.product ? getLocalisedString(p.product.name, language) : "?????");
    });
    return "".concat(nameValues.slice(0, 2).join(", ")).concat(nameValues.length > 2 ? ", ..." : "");
}
function getReservationProductImages(reservation) {
    let newImages = [];
    for (let vendingProduct of reservation.vendingProducts){
        var ref;
        if (vendingProduct === null || vendingProduct === void 0 ? void 0 : (ref = vendingProduct.product) === null || ref === void 0 ? void 0 : ref.imageUrl) {
            var ref1, ref2;
            newImages.push(vendingProduct.product.imageUrl);
            if ((ref1 = vendingProduct.product) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.includedProducts) === null || ref2 === void 0 ? void 0 : ref2.length) {
                for (let includedProduct of vendingProduct.product.includedProducts){
                    var ref3;
                    if (includedProduct === null || includedProduct === void 0 ? void 0 : (ref3 = includedProduct.product) === null || ref3 === void 0 ? void 0 : ref3.imageUrl) {
                        newImages.push(includedProduct.product.imageUrl);
                    }
                }
            }
        }
    }
    return newImages.filter((img)=>!!img);
}
function getProductCollectionItemsSummary(products) {
    let language = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .LanguageEnum.Nl */ .Go.Nl;
    return products.filter((p)=>{
        var ref;
        return !!((p === null || p === void 0 ? void 0 : (ref = p.product) === null || ref === void 0 ? void 0 : ref.unitType) && (p === null || p === void 0 ? void 0 : p.amount));
    }).map((p)=>{
        var ref;
        var ref1;
        return "- ".concat((0,_number__WEBPACK_IMPORTED_MODULE_1__/* .formatProductUnitAmount */ .uu)(p.amount, (ref1 = (ref = p.product) === null || ref === void 0 ? void 0 : ref.unitType) !== null && ref1 !== void 0 ? ref1 : _generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UnitEnumType.Unit */ .Rx.Unit), " ").concat(p.product ? getLocalisedString(p.product.name, language) : "?????");
    }).join("\n");
}
function getReservationPrices(reservation) {
    var _vendingTotalPrice;
    const vendingTotalPrice = (_vendingTotalPrice = reservation.vendingTotalPrice) !== null && _vendingTotalPrice !== void 0 ? _vendingTotalPrice : 0;
    const vendingDiscount = reservation.vendingDiscount ? reservation.vendingDiscount / 10000 : 0;
    const discountAmount = vendingTotalPrice * vendingDiscount;
    const totalPriceWithDiscount = vendingTotalPrice - discountAmount;
    var _vendingTotalPrice1;
    return {
        discountAmount,
        totalPriceWithDiscount,
        totalPrice: (_vendingTotalPrice1 = reservation.vendingTotalPrice) !== null && _vendingTotalPrice1 !== void 0 ? _vendingTotalPrice1 : 0
    };
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [458,444,389,960,774,888,179], function() { return __webpack_exec__(3295); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);